import { Button, Tooltip } from "antd";
import { InfoIconOutlined } from "../../../../../atoms/CustomIcons";

interface TabsHeaderProps {
  title: string;
  description: string;
  tooltip: string;
}

export default function TabsHeader({
  title,
  description,
  tooltip,
}: TabsHeaderProps) {
  return (
    <>
      <div className="tabsHeader">
        <div>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        <Tooltip title={tooltip}>
          <Button
            type="text"
            className="info_btn outlined-btn"
            style={{ padding: "6px" }}
          >
            <InfoIconOutlined />
          </Button>
        </Tooltip>
      </div>
    </>
  );
}
